import { Modal, Select } from "antd";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Marketing as UploadMarketing,
  get_marketing,
} from "../actions/admin/Action";
import { get_regions } from "../actions/orders";
import download from "../assets/download.svg";
import trash from "../assets/trash.svg";
import { apis } from "../config/apis";
import endpoint from "../config/endpoint";
import { NavWrap } from "./ShopForTyres";
import * as yup from "yup";
const Marketing = () => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      category: undefined,
      file: null,
      kdgrp: "",
    },
    validationSchema: yup.object().shape({
      category: yup.string().required("Category is required."),
      file: yup.mixed().required("Attachment is required."),
      kdgrp: yup.string().required("Zone is required."),
    }),
    onSubmit: (vals) => {
      let formData = new FormData();
      formData.append("category", vals.category);
      formData.append("file", vals.file);
      formData.append("kdgrp", vals.kdgrp);
      dispatch({
        type: UploadMarketing.REQUEST,
        payload: formData,
      });
    },
  });
  const [uploadModal, setUploadModal] = useState(false);
  const [size, setSize] = useState(0);
  const marketing = useSelector((state) => state?.admin?.marketing);
  const getMarketing = useSelector(
    (state) => state?.admin?.get_marketing?.data?.marketings
  );
  const origins = useSelector(
    (state) => state?.orders?.regions?.data?.zones || []
  );

  const zones = {
    z1: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z6: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z4: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z5: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z3: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
    z2: [
      { label: "Logo", value: "logo" },
      { label: "Brand Manual", value: "brand_manual" },
      { label: "Catalog", value: "catalouges" },
      { label: "POS Guideline", value: "pos_material" },
    ],
  };

  const labels = {
    Z1: "USA/Puerto - Radar USA (Z1)",
    Z2: "MEAI/Latam - Radar MEAI/Latam (Z2)",
    Z3: "APAC - Radar APAC (Z3)",
    Z4: "Canada - Radar Canada (Z4)",
    Z5: "Europe - Radar Europe (Z5)",
    Z6: "USA - OmniSoucre USA (Z6)",
  };

  const labels1 = {
    Z1: "Z1 - USA/Puerto",
    Z2: "Z2 - MEA/Latin",
    Z3: "Z3 - APAC",
    Z4: "Z4 - Canada",
    Z5: "Z5 - Europe",
    Z6: "Z6 - OmniSoucre USA",
  };
  useEffect(() => {
    dispatch(
      get_marketing({
        email: localStorage.getItem("email"),
      })
    );
    dispatch(
      get_regions({
        email: localStorage.getItem("email"),
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (marketing?.success) {
      toast.success(marketing?.data?.message);
      dispatch(
        get_marketing({
          email: localStorage.getItem("email"),
        })
      );
      formik.resetForm();
      document.getElementById("file").value = "";
      setUploadModal(false);
      setSize(0);
      dispatch({
        type: UploadMarketing.RESET,
      });
    }
    // eslint-disable-next-line
  }, [marketing]);

  const onDelete = (id) => {
    endpoint
      .post(apis.admin.admin_marketing + `/${id}?admin=true`,{
        email: localStorage.getItem("email"),
      })
      .then((res) => {
        if (res.data) {
          toast.success("Deleted Successfully.");
          dispatch(
            get_marketing({
              email: localStorage.getItem("email"),
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <NavWrap>
      <Modal
        title="Upload Marketing Files"
        visible={uploadModal}
        onCancel={() => {
          setUploadModal(false);
          setSize(0);
          formik.resetForm();
        }}
        footer={null}
      >
        <form onSubmit={formik.handleSubmit} className="marketing-form">
          <div className="mb1">
            <label>Select Zone</label>
            <Select
              className="w100"
              placeholder="Select Zone"
              options={
                Array.isArray(origins) &&
                origins?.map((ele) => ({ label: labels[ele], value: ele }))
              }
              value={formik.values.kdgrp}
              onChange={(val) => {
                formik.setFieldValue("kdgrp", val);
              }}
            />
            {formik?.errors?.kdgrp && formik?.touched?.kdgrp && (
              <div className="error-text mtHalf">{formik?.errors?.kdgrp}</div>
            )}
          </div>
          <div className="mb1">
            <label>Select Category</label>
            <Select
              className="w100"
              placeHolder="Select Category"
              options={zones?.[formik?.values?.kdgrp?.toLocaleLowerCase()]}
              value={formik.values.category}
              onChange={(val) => {
                formik.setFieldValue("category", val);
              }}
            />
            {formik?.errors?.category && formik?.touched?.category && (
              <div className="error-text mtHalf">
                {formik?.errors?.category}
              </div>
            )}
          </div>
          <div className="mb1">
            <input
              type={"file"}
              className="ant-input"
              style={{
                padding: "10px",
              }}
              id="file"
              onChange={(e) => {
                formik.setFieldValue("file", e.target.files[0]);
                setSize(e.target.files[0]?.size);
              }}
            />
            <span className="ml1 note">
              Note: File should be less than 250MB
            </span>
            {formik?.errors?.file && formik?.touched?.file && (
              <div className="error-text mtHalf">{formik?.errors?.file}</div>
            )}
            {size > 262144000 && (
              <div className="error-text mtHalf">
                {"File should be less than 250MB"}
              </div>
            )}
          </div>
          <div>
            <button
              className="cancel-btn mr1"
              type="button"
              onClick={() => {
                setUploadModal(false);
                setSize(0);
                formik.resetForm();
              }}
            >
              {"Close"}
            </button>
            <button
              disabled={marketing?.loading || size > 262144000}
              className="primary-btn"
              type="submit"
            >
              {marketing?.loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </form>
      </Modal>
      <div className="marketing">
        <div className="flex-between">
          <h3>OMNI Marketing Material</h3>
          <button
            className="primary-btn"
            onClick={() => {
              setUploadModal(true);
            }}
          >
            Upload
          </button>
        </div>
        <ul className="download-items">
          <h2>Logo</h2>
          {getMarketing &&
            getMarketing?.length &&
            getMarketing
              ?.filter((ele) => ele.category === "logo")
              ?.map((ele) => (
                <li>
                  <img src={download} alt="download" width={20} height={12} />
                  <strong>
                    <span
                      onClick={() => {
                        window.open(ele.file, "_blank");
                      }}
                    >
                      {ele.file_name} - ({labels1[ele.kdgrp]})
                    </span>
                    <img
                      src={trash}
                      alt={"alt"}
                      width={16}
                      className="ml1 cursor"
                      style={{ marginTop: -2 }}
                      onClick={() => {
                        onDelete(ele.id);
                      }}
                    />
                  </strong>
                </li>
              ))}
        </ul>
        <br />
        <ul className="download-items">
          <h2>Brand Manual</h2>
          {getMarketing &&
            getMarketing?.length &&
            getMarketing
              ?.filter((ele) => ele.category === "brand_manual")
              ?.map((ele) => (
                <li>
                  <img src={download} alt="download" width={20} height={12} />
                  <strong>
                    <span
                      onClick={() => {
                        window.open(ele.file, "_blank");
                      }}
                    >
                      {ele.file_name} - ({labels1[ele.kdgrp]})
                    </span>
                    <img
                      src={trash}
                      alt={"alt"}
                      width={16}
                      className="ml1 cursor"
                      style={{ marginTop: -2 }}
                      onClick={() => {
                        onDelete(ele.id);
                      }}
                    />
                  </strong>
                </li>
              ))}
        </ul>
        <ul className="download-items">
          <h2>Catalog</h2>
          {getMarketing &&
            getMarketing?.length &&
            getMarketing
              ?.filter((ele) => ele.category === "catalouges")
              ?.map((ele) => (
                <li>
                  <img src={download} alt="download" width={20} height={12} />
                  <strong>
                    <span
                      onClick={() => {
                        window.open(ele.file, "_blank");
                      }}
                    >
                      {ele.file_name} - ({labels1[ele.kdgrp]})
                    </span>
                    <img
                      src={trash}
                      alt={"alt"}
                      width={16}
                      className="ml1 cursor"
                      style={{ marginTop: -2 }}
                      onClick={() => {
                        onDelete(ele.id);
                      }}
                    />
                  </strong>
                </li>
              ))}
        </ul>
        <ul className="download-items">
          <h2>POS Guidelines</h2>
          {getMarketing &&
            getMarketing?.length &&
            getMarketing
              ?.filter((ele) => ele.category === "pos_material")
              ?.map((ele) => (
                <li>
                  <img src={download} alt="download" width={20} height={12} />
                  <strong>
                    <span
                      onClick={() => {
                        window.open(ele.file, "_blank");
                      }}
                    >
                      {ele.file_name} - ({labels1[ele.kdgrp]})
                    </span>
                  </strong>
                  <img
                    src={trash}
                    alt={"alt"}
                    width={16}
                    className="ml1 cursor"
                    style={{ marginTop: -2 }}
                    onClick={() => {
                      onDelete(ele.id);
                    }}
                  />
                </li>
              ))}
        </ul>
      </div>
    </NavWrap>
  );
};

export default Marketing;
